import React, { useCallback } from 'react';
import type { ResolveThunks } from 'react-redux';
import { connect } from 'react-redux';
import { searchProjects } from 'redux/modules/projects.actions';
import { getIsLoadingProjects, getProjectsFetchingStatus } from 'redux/selectors/projects';
import type { IState } from 'redux/state';
import type { FilterGroupValues } from 'types/project';
import ProjectFilterDropdown from './ProjectFilterDropdown';

type OwnProps = {
  userId?: number;
  projectSearchFilter?: FilterGroupValues;
};
const mapStateToProps = (state: IState) => ({
  projectFetchingStatus: getProjectsFetchingStatus(state),
  isLoadingProjects: getIsLoadingProjects(state),
});
const mapDispatchToProps = {
  searchProjects,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type ActionProps = ResolveThunks<typeof mapDispatchToProps>;
type ProxyProps = Omit<React.ComponentProps<typeof ProjectFilterDropdown>, 'onSearch'>;

type Props = ProxyProps & OwnProps & StateProps & ActionProps;
const SearchingProjectFilterDropdown: React.FC<Props> = props => {
  const {
    userId,
    searchProjects,
    projectSearchFilter,
    projectFetchingStatus,
    isLoadingProjects,
    ...rest
  } = props;

  const onSearch = useCallback(
    (filterString: string, filterGroup?: FilterGroupValues) => {
      return searchProjects(filterString, userId ?? null, filterGroup);
    },
    [searchProjects, userId]
  );

  return (
    <ProjectFilterDropdown
      {...rest}
      isLoading={rest.isLoading || isLoadingProjects}
      onSearch={onSearch}
      projectFetchingStatus={projectFetchingStatus}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchingProjectFilterDropdown);
